import React from 'react'
import PriceFormatter from '../../utils/price-formatter'
import createReactClass from 'create-react-class'


var UpsaleGroupPrintsTotal = createReactClass({

  getProductCost: function () {
    var firstItem = this.props.itemList[0];

    return firstItem.getUnitPrice(2, true);
  },
  getTotal: function () {
    var total = 0.0;

    for (var i = 0; i < this.props.itemList.length; i++) {
      total += this.props.itemList[i].getPrice(10, true);
    }

    return Math.round(total*100)/100;
  },
  render: function() {
    return (
      <div className="ope-upsale__group__printstotal">
        <span className="ope-upsale__group__printstotal__label">{_('Prints')}</span>
        <span className="ope-upsale__group__printstotal__productCost ">{PriceFormatter(this.getProductCost())}</span>
        <span className="ope-upsale__group__printstotal__total ">{PriceFormatter(this.getTotal())}</span>
      </div>
    );
  }
});

export default UpsaleGroupPrintsTotal;
